import { Icons, Row, Stack, Text } from '..'

export function Warning({ title, content, children }) {
  return (
    <Row alignItems="center" spacing={2} width="90%">
      <Icons.Error sx={{ fontSize: '3rem', justifyContent: 'right', ml: 3 }} color="error" />
      <Stack spacing={2} sx={{ flex: 1, alignItems: 'flex-end', textAlign: 'right' }}>
        {title && <Text.H5 data-testid="profileWarningMessage">{title}</Text.H5>}
        {typeof content === 'string' ? <Text.Body>{content}</Text.Body> : content}
        {children && <Row sx={{ justifyContent: { md: 'flex-end' } }}>{children}</Row>}
      </Stack>
    </Row>
  )
}
